import React, { forwardRef, useContext } from 'react';
import { EditorContext } from 'components/Editor';

import Icon from 'components/Misc/Icon';

const Download = forwardRef(({ src, style, children, ...attributes }, ref) => {
	// Use editor's context
	const { config } = useContext(EditorContext);

	return (
		<figure
			ref={ref}
			style={style}
			contentEditable={false}
			{...attributes}
		>
			<a
				download
				target="_blank"
				rel="noreferrer"
				href={`${process.env.REACT_APP_CDN}/${config.path}/${config.folder}/${src}`}
				className="py-2 px-3 space-x-2 flex items-center rounded-lg text-neutral-800 dark:text-white bg-neutral-50 dark:bg-neutral-700 group cursor-pointer transition-colors"
			>
				<Icon
					icon="file_download"
					className="text-3xl text-neutral-800 dark:text-white group-hover:text-amber-500 transition-colors"
				/>

				<span>Lejupielādēt pievienoto failu</span>
			</a>

			{children}
		</figure>
	);
});

export default Download;
